import React from "react";
import { useFormContext } from "react-hook-form";
import { UserRoleNames } from "common/authorization/policies";
import { AuthContext } from "../../../../../../Authorization/AuthContext";
import { Label } from "../../../../../../Inputs";
import { Checkbox, Text } from "../../../../../../Inputs/react-hook-form";
import { SelectedSubmissionsBuilderField } from "../../reducer";
import { RoleAndGroupSelector } from "../../RoleAndGroupSelector";
import { SubmissionsBuilderFieldSettings } from "../../types";
import { SubmissionsBuilderFormDataStructure } from "../../types";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import {
  DisplaySettingsSection,
  FieldPermissionsConfig,
  FieldSettingConfig,
} from "./shared";

const UserWidgetSettings = ({
  fieldPath,
  isModuleInput,
  readOnly,
}: SelectedSubmissionsBuilderField & SubmissionsBuilderFieldSettings) => {
  const { register, control } =
    useFormContext<SubmissionsBuilderFormDataStructure>();
  const { account } = React.useContext(AuthContext);
  const userGroups = account?.userGroups || [];

  return (
    <WidgetSettingsContainer>
      <FieldSettingConfig
        fieldPath={fieldPath}
        isModuleInput={isModuleInput}
        isFormulaField={false}
        readOnly={readOnly}
      />
      <div>
        <Label text={"Placeholder text"} htmlFor={`${fieldPath}.placeholder`} />
        <Text {...register(`${fieldPath}.placeholder`)} disabled={readOnly} />
      </div>
      <div>
        <Label text={"Helper text"} htmlFor={`${fieldPath}.helperText`} />
        <Text {...register(`${fieldPath}.helperText`)} disabled={readOnly} />
      </div>
      <div>
        <Label
          text={"Which user groups should be displayed in the dropdown?"}
        />
        <RoleAndGroupSelector
          control={control}
          name={`${fieldPath}.userGroupSelection`}
          options={{
            roles: [...UserRoleNames],
            userGroups,
          }}
          iconName="users-round"
        />
      </div>
      <Checkbox
        control={control}
        name={`${fieldPath}.randomizeOptionOrder`}
        label="Randomize display order of dropdown options"
        disabled={readOnly}
      />
      <FieldPermissionsConfig fieldPath={fieldPath} />
      <DisplaySettingsSection fieldPath={fieldPath} readOnly={readOnly} />
    </WidgetSettingsContainer>
  );
};

UserWidgetSettings.displayName = "UserWidgetSettings";

export default UserWidgetSettings;
